import SnippetsModal from './SnippetsModal';
export default SnippetsModal;